"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = normalizeProtocol;
// ensure protocol has trailing : if missing
function normalizeProtocol(protocol) {
  if (protocol && !protocol.endsWith(":")) return protocol + ":";
  return protocol;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-emoji-render/lib/normalizeProtocol.js
// module id = 180
// module chunks = 34471704633725 55213770944713 114276838955818 173894859265406 216468464745311